/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";

const url = process.env.REACT_APP_SERVER_URL + '/marcas';

export const fetchMarcas = async (comando, currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> FetchMarcas');
    //console.log(currentUser);

    let body = { comando };
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/fetch`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_MARCAS', payload: result });
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const EnviarNuevaMarca = async (datos, currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> NuevaMarca');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/nuevaMarca`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const borrarMarca = async (datos, currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> BorrarMarca');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/borrarMarca`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}


